<template>
  <div class="vocation">
    <div class="top-banner">
      职 业 教 育
    </div>
    <!-- 产教融合 -->
    <div class="vocation-instudry">
      <div class="g-box">
        <div class="top-title">产教融合</div>
        <div class="sub-title">
          构建符合新时代新经济特征的产学融合2.0新培养模式
        </div>
        <div class="content">
          <img :src="instudryInfo.image" alt="" class="img" />
        </div>
      </div>
    </div>
    <!-- 合作院校 -->
    <div class="vocation-partners">
      <div class="g-box">
        <div class="title">合作院校</div>
        <div class="sub-tit">
          与多所高校达成合作，充分发挥广泛连接产业界与教育界的桥梁作用
        </div>
        <div class="content">
          <div class="swiper-container my-swiper" id="swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, i) in partnersList"
                :key="i"
              >
                <div class="items">
                  <div class="item" v-for="(el, j) in item" :key="j">
                    <img :src="el.image" alt="" class="img" />
                    <div class="tt">{{ el.title }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination my-pagi"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import Swiper from "swiper";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      partnersList: [],
      instudryInfo: {}
    };
  },
  components: {},
  async mounted() {
    // 产教融合
    const menuId = this.getMenuId("职业教育-教育展示-产教融合");
    if (menuId) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId
      });
      this.instudryInfo = data[0] || {};
    }
    // 合作院校
    const menuId1 = this.getMenuId("职业教育-教育展示-合作院校");
    if (menuId1) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId1
      });
      const arr = [];
      for (let i = 0; i < data.length; i += 5) {
        arr.push(data.slice(i, i + 5));
      }
      console.log(arr, "arr");
      this.partnersList = arr;
      this.UserSwiper();
    }
  },
  methods: {
    UserSwiper() {
      new Swiper("#swiper", {
        loop: false,
        observer: true,
        observerParents: true,
        watchSlidesVisibility: true,
        pagination: {
          el: ".swiper-pagination"
        }
      });
    }
  }
};
</script>
<style lang="less">
.vocation {
  .top-banner {
    padding-top: 80px;
    text-align: center;
    height: 280px;
    background: url("../../assets/img/vocation.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    font-size: 60px;
    color: #fff;
    line-height: 84px;
    letter-spacing: 8px;
  }
  //  产教融合
  &-instudry {
    padding: 80px 0 70px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #0f53ff;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #272727;
    }
    .content {
      margin-top: 40px;
      width: 1200px;
      height: 480px;
      .img {
        width: 1200px;
        height: 480px;
      }
    }
  }
  // 合作院校
  &-partners {
    padding-top: 80px;
    height: 620px;
    background: url("../../assets/img/partner-bg.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #fff;
      line-height: 50px;
    }
    .sub-tit {
      padding-top: 12px;
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.61);
    }
    .content {
      display: flex;
      margin-top: 60px;
      .items {
        display: flex;
        width: 1200px;
        .item {
          margin-right: 25px;
          padding: 20px 30px;
          width: 220px;
          height: 260px;
          background: #fff;
          box-sizing: border-box;
          .img {
            width: 160px;
            height: 160px;
          }
          .tt {
            padding-top: 20px;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #000;
            line-height: 22px;
          }
        }
        .item:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
}
.my-swiper {
  padding-bottom: 60px;
  --swiper-theme-color: #fff;
}
</style>
